import React from 'react';
import { string, shape, arrayOf, bool, node } from 'prop-types';
import { prop } from 'ramda';
import styled from 'styled-components';
import { Box } from 'grid-styled';
import Paper from 'material-ui/Paper';

import { Display2Light, SubheadingBold, Text } from '../Text';
import LinkButton from './LinkButton';

const InnerContainer = styled(({ sideColor, pointerEvents, ...props }) => (
  <Paper {...props} />
))`
  display: flex;
  align-items: center;
  border-left: 2px solid ${prop('sideColor')};
  padding: 12px 16px;
  transition: none !important;
  pointer-events: ${prop('pointerEvents')};
`;

export const GenericTooltip = ({
  sideColor,
  title,
  subtitle,
  link,
  mainValue,
  lines,
  tableRows,
  hoverable,
  compare,
}) => (
  <InnerContainer
    pointerEvents={hoverable ? 'auto' : 'none'}
    sideColor={sideColor}
  >
    <Box pr={2}>
      <Display2Light>{mainValue}</Display2Light>
    </Box>

    <Box style={{ marginTop: '-5px', flex: '1 1 auto' }}>
      <SubheadingBold lineHeight={1.87}>{title}</SubheadingBold>

      {subtitle ? (
        <Text whiteSpace="nowrap" is="div" lineHeight={1.6}>
          {subtitle}
        </Text>
      ) : null}

      {link && compare === 'none' ? <LinkButton>{link}</LinkButton> : null}

      {lines.map((line, i) => (
        <Text
          color="grey500"
          whiteSpace="nowrap"
          is="div"
          key={i}
          lineHeight={1.65}
        >
          {line}
        </Text>
      ))}

      {tableRows.length > 0 ? (
        <table style={{ borderSpacing: 0, lineHeight: 1 }}>
          <tbody>
            {tableRows.map(({ value, text }, i) => (
              <tr key={i}>
                <td style={{ padding: 0, paddingRight: 5 }}>
                  <Text whiteSpace="nowrap">{value}</Text>
                </td>
                <td style={{ padding: 0 }}>
                  <Text color="grey500" whiteSpace="nowrap">
                    {text}
                  </Text>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </Box>
  </InnerContainer>
);

GenericTooltip.propTypes = {
  mainValue: node.isRequired,
  sideColor: string.isRequired,
  hoverable: bool,
  title: node.isRequired,
  subtitle: node,
  link: node,
  lines: arrayOf(node),
  tableRows: arrayOf(
    shape({
      value: string.isRequired,
      text: string.isRequired,
    }),
  ),
};

GenericTooltip.defaultProps = {
  tableRows: [],
  lines: [],
};

export default GenericTooltip;



// WEBPACK FOOTER //
// ./src/components/GenericTooltip/GenericTooltip.jsx